import type { AppointmentStatusValue } from './api-types';

/**
 * Como cada status é dito ao cliente.
 *
 * Num lugar só. Espalhar `status === 'NO_SHOW' ? 'Faltou' : …` pelas telas
 * garantiria que a próxima tela mostrasse `NO_SHOW` cru para quem só quer saber
 * se o corte está de pé.
 */
export const APPOINTMENT_STATUS: Record<
  AppointmentStatusValue,
  { label: string; tone: 'neutral' | 'success' | 'warning' | 'danger' }
> = {
  PENDING: { label: 'Aguardando confirmação', tone: 'warning' },
  CONFIRMED: { label: 'Confirmado', tone: 'success' },
  COMPLETED: { label: 'Atendido', tone: 'neutral' },
  CANCELLED: { label: 'Cancelado', tone: 'danger' },
  NO_SHOW: { label: 'Não compareceu', tone: 'danger' },
};

export function statusLabel(status: AppointmentStatusValue): string {
  return APPOINTMENT_STATUS[status].label;
}
